var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.schoolPredicate)?_c('mdm-stripe',{attrs:{"text":_vm.withAmount ? _vm.stripeAttrs.amount : _vm.stripeAttrs.text,"color":_vm.stripeAttrs.color}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }